import React from 'react';

export default function BoyBackpackSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="23.12,10.18 14.2,10.18 14.2,3.49 23.12,3.49" fill="#6177C5" />
      <polygon points="6.94,12.26 3.79,9.1 5.37,7.53 8.52,10.68" fill="#6177C5" />
      <polygon points="30.54,13.09 20.25,17.36 15.98,7.06 26.28,2.79" fill="#6177C5" />
      <polygon points="19.75,17.52 9.46,13.26 12.87,5.02 23.17,9.29" fill="#6177C5" />
      <polygon points="36.21,9.44 33.06,12.59 31.48,11.01 34.63,7.86" fill="#6177C5" />
      <polygon points="32.82,36.2 10.53,36.2 10.53,11.68 32.82,11.68" fill="#6177C5" />
      <polygon points="10.53,36.2 32.82,36.2 29.47,34.53 7.18,34.53" fill="#33478C" opacity="0.95" />
      <polygon points="10.53,36.2 7.18,34.53 7.18,10.01 10.53,11.68" fill="#33478C" opacity="0.95" />
      <polygon points="38.0,32.39 32.98,32.39 32.98,26.81 38.0,26.81" fill="#6177C5" />
      <polygon points="32.98,32.39 38.0,32.39 34.32,30.55 29.31,30.55" fill="#33478C" opacity="0.95" />
      <polygon points="32.98,32.39 29.31,30.55 29.31,24.97 32.98,26.81" fill="#33478C" opacity="0.95" />
      <polygon points="10.69,32.39 5.68,32.39 5.68,26.81 10.69,26.81" fill="#6177C5" />
      <polygon points="5.68,32.39 10.69,32.39 7.02,30.55 2.0,30.55" fill="#33478C" opacity="0.95" />
      <polygon points="5.68,32.39 2.0,30.55 2.0,24.97 5.68,26.81" fill="#33478C" opacity="0.95" />
      <polygon points="37.28,36.2 32.82,36.2 32.82,27.29 37.28,27.29" fill="#6177C5" />
      <polygon points="32.82,36.2 37.28,36.2 33.93,34.53 29.47,34.53" fill="#33478C" opacity="0.95" />
      <polygon points="32.82,36.2 29.47,34.53 29.47,25.61 32.82,27.29" fill="#33478C" opacity="0.95" />
      <polygon points="10.53,36.2 6.07,36.2 6.07,27.29 10.53,27.29" fill="#6177C5" />
      <polygon points="6.07,36.2 10.53,36.2 7.18,34.53 2.72,34.53" fill="#33478C" opacity="0.95" />
      <polygon points="6.07,36.2 2.72,34.53 2.72,25.61 6.07,27.29" fill="#33478C" opacity="0.95" />
      <polygon points="11.03,33.95 7.88,30.8 9.46,29.23 12.61,32.38" fill="#6177C5" />
      <polygon points="36.8,30.8 33.65,33.95 32.07,32.38 35.23,29.23" fill="#6177C5" />
      <polygon points="35.55,31.16 12.14,31.16 12.14,25.59 35.55,25.59" fill="#6177C5" />
      <polygon points="12.14,31.16 35.55,31.16 33.37,30.07 9.97,30.07" fill="#33478C" opacity="0.95" />
      <polygon points="12.14,31.16 9.97,30.07 9.97,24.5 12.14,25.59" fill="#33478C" opacity="0.95" />
      <polygon points="34.82,37.21 12.53,37.21 12.53,26.06 34.82,26.06" fill="#6177C5" />
      <polygon points="12.53,37.21 34.82,37.21 32.82,36.2 10.53,36.2" fill="#33478C" opacity="0.95" />
      <polygon points="12.53,37.21 10.53,36.2 10.53,25.06 12.53,26.06" fill="#33478C" opacity="0.95" />
    </svg>
  );
}
